"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const column_1 = __importDefault(require("./components/column"));
const countryList_1 = __importDefault(require("./components/countryList"));
const insurances_1 = __importDefault(require("./components/insurances"));
const listGroup_1 = __importStar(require("./components/listGroup"));
const logos_1 = __importDefault(require("./components/logos"));
const useQuery_1 = __importDefault(require("./hooks/useQuery"));
const Styles = __importStar(require("./styles"));
const Footer = (_a) => {
    var { afterInit, defaultData, dataPath = 'https://www.veepee.fr/api/navigation/getfooter/:siteId', onLinkClick, siteId, paymentsNames } = _a, props = __rest(_a, ["afterInit", "defaultData", "dataPath", "onLinkClick", "siteId", "paymentsNames"]);
    const { loading, error, data } = (0, useQuery_1.default)(defaultData, siteId, dataPath, afterInit);
    if (loading || error)
        return null;
    const { countryBlock, listColumnFooterHeaderLink, listColumnFooterLink, localizedLogo, servicesAndRewards } = data.datas;
    return ((0, jsx_runtime_1.jsxs)(Styles.Footer, Object.assign({}, props, { children: [(0, jsx_runtime_1.jsxs)(Styles.FooterContent, { children: [(0, jsx_runtime_1.jsx)(listGroup_1.default, { direction: listGroup_1.Direction.Row, mobileDirection: listGroup_1.Direction.Row, children: listColumnFooterHeaderLink.map((column, index) => ((0, react_1.createElement)(column_1.default, Object.assign({}, column, { paymentsNames: paymentsNames, key: index, isHorizontal: true, "data-facil-iti": "footer--column", onLinkClick: onLinkClick, hideTitleMobile: true })))) }), (0, jsx_runtime_1.jsx)(listGroup_1.default, { direction: listGroup_1.Direction.Row, children: listColumnFooterLink.map((column, index) => ((0, react_1.createElement)(column_1.default, Object.assign({}, column, { paymentsNames: paymentsNames, key: index, "data-facil-iti": "footer--column", onLinkClick: onLinkClick })))) }), (0, jsx_runtime_1.jsxs)(listGroup_1.default, { direction: listGroup_1.Direction.Row, "data-facil-iti": "footer--credit", children: [(0, jsx_runtime_1.jsx)(insurances_1.default, { items: servicesAndRewards }), countryBlock && (0, jsx_runtime_1.jsx)(countryList_1.default, Object.assign({}, countryBlock))] })] }), (0, jsx_runtime_1.jsx)(Styles.LogosContent, { children: (0, jsx_runtime_1.jsx)(logos_1.default, { localizedLogo: localizedLogo, siteId: siteId }) })] })));
};
exports.Footer = Footer;
exports.default = exports.Footer;
